import * as React from "react";
import { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { PanelGroup, Panel } from "components/bootstrap";
import { STEP_KEY as SERVER_CONFIG_KEY } from "./ServerConfigStep";
import { STEP_KEY as USER_SYNC_KEY } from "./UserSyncStep";
import BackendWizardContext from "./BackendWizardContext";
import ServerConnectionTest from "./ServerConnectionTest";
import UserLoginTest from "./UserLoginTest";
const StyledPanelGroup = styled(PanelGroup)`
  &.panel-group .panel {
    margin-top: 0;
    border-color: ${(props) => props.theme.colors.input.border};
    background-color: ${(props) => props.theme.colors.global.contentBackground};

    .panel-heading {
      background-color: ${(props) => props.theme.colors.table.row.backgroundStriped};
    }

    &:not(:first-child) {
      border-top: 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    &:not(:last-child) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
`;
const Sidebar = ({ prepareSubmitPayload }) => {
  const [activeKey, setActiveKey] = useState(SERVER_CONFIG_KEY);
  const { setStepsState, ...stepsState } = useContext(BackendWizardContext);
  useEffect(() => {
    setActiveKey(stepsState.activeStepKey);
  }, [stepsState.activeStepKey]);
  return /* @__PURE__ */ React.createElement(
    StyledPanelGroup,
    {
      accordion: true,
      activeKey,
      id: "sidebar-server-response",
      onSelect: setActiveKey
    },
    /* @__PURE__ */ React.createElement(Panel, { eventKey: SERVER_CONFIG_KEY }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, { toggle: true }, "Server Connection Check")), /* @__PURE__ */ React.createElement(Panel.Body, { collapsible: true }, /* @__PURE__ */ React.createElement(ServerConnectionTest, { prepareSubmitPayload }))),
    /* @__PURE__ */ React.createElement(Panel, { eventKey: USER_SYNC_KEY }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, { toggle: true }, "User Login Test")), /* @__PURE__ */ React.createElement(Panel.Body, { collapsible: true }, /* @__PURE__ */ React.createElement(UserLoginTest, { prepareSubmitPayload })))
  );
};
export default Sidebar;
